<div class="listing-tile-container" (click)="goToListing($event)">

  <div class="listing-picture-row">
      <img *ngIf="this.listableListingTimeline.isComingSoon() && !this.listableListingTimeline.photos.length" src="assets/houwzer/houwzer-coming-soon-gray.png" class="coming-soon-image" />
      <img *ngIf="!this.listableListingTimeline.isComingSoon() && !this.listableListingTimeline.photos.length" src="assets/product/no_photos.png" class="no-photos-image" />
      <div *ngIf="this.listableListingTimeline.photos.length" class="swiper-container">
        <inline-carousel
          [alt]="listableListingTimeline.name"
          [photos]="listableListingTimeline.photos"
          [inlineCarouselOptions]="inlineCarouselOptions"
        ></inline-carousel>
      </div>
  </div>

  <div class="listing-info">
    <div class="listing-info-inner">
      <div class="current-info">
        <span
          class="status"
          [class.pending]="this.listableListingTimeline.isPending()"
          [class.closed]="this.listableListingTimeline.isClosed()"
          [class.active-under-contract]="this.listableListingTimeline.isActiveUnderContract()"
        >
          {{ this.listableListingTimeline.status() }}
        </span>
        <span class="price">{{ this.listableListingTimeline.price() }}</span>
      </div>
      <div class="address">
        <div *ngIf="listableListingTimeline.street_address && listableListingTimeline.street_address.length">{{ listableListingTimeline.street_address }} {{ listableListingTimeline.unit_number }}</div>
        <div>{{ listableListingTimeline.city }}, {{ listableListingTimeline.state }} {{ listableListingTimeline.zip_code }}</div>
        <div *ngIf="listableListingTimeline.neighborhood()">{{ listableListingTimeline.neighborhood() }}</div>
      </div>
      <div class="savings-link">
        <savings-link [savingsInCents]="listableListingTimeline.savings_in_cents"></savings-link>
      </div>
    </div>
  </div>

  <div class="listing-fields">
    <div class="listing-fields-inner">
      <div class="listing-field">
        <span class="listing-field-value">{{ this.listableListingTimeline.timelineFieldValue('bedrooms') }}</span>
        <span class="listing-field-label">Beds</span>
      </div>
      <div class="listing-field">
        <span class="listing-field-value">{{ this.listableListingTimeline.bathrooms() }}</span>
        <span class="listing-field-label">Baths</span>
      </div>
      <div class="listing-field" *ngIf="this.listableListingTimeline.totalFinishedSqft()">
        <span class="listing-field-value">{{ this.listableListingTimeline.totalFinishedSqft() }}</span>
        <span class="listing-field-label">sqft</span>
      </div>
    </div>
  </div>
</div>
